export default "__VITE_ASSET__DkG5ySmf__"